import React, { useContext, useState } from 'react';
import LanguageContext from './hooks/LanguageContext';
import parse from 'html-react-parser';
import ModalInstruction from './ModalInstruction';
import { getText } from '../utils/languageUtils';



const SingleChoiceQuizImage = ({ question, selectedOptions, setSelectedOptions, answer, isMarked }) => {
  const { language, translations: translationData } = useContext(LanguageContext);
  const single_choice_img_quiz = translationData?.single_choice_img_quiz || {};
  const [show, setShow] = useState(false);

  const handleOptionChange = (id, title) => {
    setSelectedOptions({ id, title });
  };

  const renderQuestionPrompt = () => {
    const title = getText(question.question_title, language);
    const category = question.question_category?.english || question.question_category;

    // Map category to suffix key
    const suffixKey = `suffix_${category}`;
    const prefix = getText(single_choice_img_quiz.can_you_share, language);
    const suffix = getText(single_choice_img_quiz[suffixKey], language);

    return (
      <div className="emailText text-start w-100" style={{ marginLeft: "7%" }}>
        <p style={{ marginBottom: 2 }}>{prefix}</p>
        <div style={{ maxWidth: "75%", fontSize: "13px", lineHeight: "18px" }}>
          {title} {suffix}
        </div>
      </div>
    );
  };


  const renderOptions = () => {
    return (question.question_option[language] || question.question_option['english'] || []).map((option, index) => {
      const isSelected = isMarked === 0 && option.id === selectedOptions?.id;
      const isMarkedChoice = isMarked === 1 && option.id === Number(answer?.course_module_item?.[0]?.option_marked?.id);

      return (
        <div className="col-6 col-lg-6 mb-4" key={index}>
          <div className="questionButton position-relative">
            <div
              className={`btn-school ms-3 ${isSelected ? 'selectedButton' : ''} ${isMarkedChoice ? 'markedChoice' : ''}`}
              style={{ fontSize: 14 }}
              onClick={() => handleOptionChange(option.id, option.title)}
            >
              {option.title}
              <div className="obj1">
                <img src={require("../assets/images/twemoji_cloud-with-rain.png")} alt="" />
              </div>
              <div className="obj2">
                <img src={require("../assets/images/star.png")} alt="" />
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className='d-flex justify-content-end'>
        <div onClick={() => setShow(true)}>
          <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' alt="Instructions" />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="sectionsBox text-center">
            <p className="mb-0">{getText(question.title, language)}</p>
          </div>
        </div>
      </div>

      {getText(question.description, language)?.length > 0 && (
        <div className="row">
          <div className="col-12">
            <div className="contentbox mb-2 mt-3">
              <div className="content_safty">{parse(getText(question.description, language))}</div>
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className="textBox pb-1 pt-2 position-relative">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                <div className="shareEmail d-flex align-items-center justify-content-start">
                  {renderQuestionPrompt()}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12">
                <form className="single-type pt-4">
                  <div className="row justify-content-center text-center">
                    {renderOptions()}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalInstruction
        show={show}
        handleClose={() => setShow(false)}
        inst={parse(getText(question.instruction, language))}
      />
    </>
  );
};

export default SingleChoiceQuizImage;
